import React, { useCallback, useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Typography,
} from '@mui/material';
import { secondUserDescriptionMap } from 'src/const';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

import QnAImage from 'src/App/assets/undrawMyAnswer.svg';
import { callApi } from 'src/core/callApi';
import { COLOR_GREY_400, COLOR_PRIMARY_1 } from 'src/colors';

const UserDescriptionFormOnGoogleAuth = ({ setIsUserDescriptionFormStatusOpen }) => {
  const [userDescription, changeUserDescription] = useState<string>('');
  const [userSubDescription, setUserSubDescription] = useState<string>('');

  const [isApiLoading, setIsApiLoading] = useState<boolean>(false);

  const userDescriptionMap = ['property_investor', 'property_manager', 'tourism', 'unclassified'];

  const handleUserDescriptionChange = useCallback(event => {
    changeUserDescription(event.target.value);
  }, []);

  const handleUserSubDescriptionChange = event => {
    setUserSubDescription(event.target.value);
  };

  const clearLocalStorageFormStatus = () => {
    localStorage.removeItem('user-description-form-to-fill');
  };

  const handleFormSubmit = async () => {
    console.log('User Description: ', userDescription);
    console.log('User Sub Description: ', userSubDescription);
    setIsApiLoading(true);

    await callApi(
      'https://8fl0ic90c1.execute-api.us-east-2.amazonaws.com/default/postGoogleAuthDataUpdate',
      {
        body: [
          {
            token: localStorage.getItem('auth-token'),
            user_description: userDescription,
            user_sub_description: userSubDescription,
          },
        ],
        method: 'post',
      },
      true
    );

    clearLocalStorageFormStatus();
    setIsUserDescriptionFormStatusOpen(false);
  };

  return (
    <>
      <Modal open={true}>
        <>
          <Box
            sx={{
              position: 'relative',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 'min(800px, 90vw)',
              boxShadow: 24,
              p: 4,
              background: '#fff',
              borderRadius: '12px',
              outline: 'none',
              border: 'none',
              WebkitBoxShadow: '0 2px 20px -12px #0003',
            }}
          >
            {isApiLoading && (
              <Box
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  background: '#fff7',
                  zIndex: 999999,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <CircularProgress sx={{ color: COLOR_PRIMARY_1 }} />
              </Box>
            )}

            <Box
              sx={{
                position: 'absolute',
                width: '40px',
                height: '40px',
                background: COLOR_GREY_400,
                color: '#fff',
                top: '-20px',
                right: '-20px',
                borderRadius: '900px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'pointer',
              }}
              onClick={() => {
                setIsUserDescriptionFormStatusOpen(false);
                clearLocalStorageFormStatus();
              }}
            >
              <CloseRoundedIcon />
            </Box>
            <Grid container spacing={1} direction="row" alignItems="center" sx={{ width: '100%' }}>
              <Grid item xs={12} sm={4}>
                <img src={QnAImage} style={{ width: '100%', objectFit: 'cover' }} />
              </Grid>
              <Grid item xs={12} sm={8}>
                <FormControl variant="outlined" fullWidth required={true}>
                  <Typography
                    variant="h5"
                    sx={{ fontSize: '18px', fontWeight: 600, color: '#3AAFA9' }}
                  >
                    How would you best describe yourself?
                  </Typography>
                  <Select
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    variant="standard"
                    required
                    fullWidth
                    label="How would you best describe yourself?"
                    value={userDescription}
                    onChange={handleUserDescriptionChange}
                  >
                    <MenuItem value={userDescriptionMap[0]}>Property Investor</MenuItem>
                    <MenuItem value={userDescriptionMap[1]}>
                      Airbnb Host / Property Manager
                    </MenuItem>
                    <MenuItem value={userDescriptionMap[2]}>Researcher / Government</MenuItem>
                    <MenuItem value={userDescriptionMap[3]}>Others</MenuItem>
                  </Select>
                </FormControl>

                {secondUserDescriptionMap[userDescription] && (
                  <FormControl
                    variant="standard"
                    fullWidth
                    required={true}
                    sx={{ marginTop: '20px' }}
                  >
                    <Typography
                      variant="h5"
                      sx={{ fontSize: '18px', fontWeight: 600, color: '#3AAFA9' }}
                    >
                      {secondUserDescriptionMap[userDescription]
                        ? Object.keys(secondUserDescriptionMap[userDescription])[0]
                        : ''}
                    </Typography>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id="sub-user-description"
                      variant="standard"
                      required
                      fullWidth
                      label={
                        secondUserDescriptionMap[userDescription]
                          ? Object.keys(secondUserDescriptionMap[userDescription])[0]
                          : ''
                      }
                      onChange={handleUserSubDescriptionChange}
                    >
                      {secondUserDescriptionMap[userDescription] &&
                        (Object as any)
                          .entries(secondUserDescriptionMap[userDescription])[0][1]
                          .map(value => <MenuItem value={value}>{value}</MenuItem>)}
                    </Select>
                  </FormControl>
                )}

                {(userSubDescription ||
                  (!secondUserDescriptionMap[userDescription] && userDescription)) && (
                  <Button
                    variant="contained"
                    sx={{
                      maxWidth: '200px',
                      marginTop: '10px',
                      color: '#fff',
                      justifySelf: 'flex-end',
                    }}
                    onClick={handleFormSubmit}
                  >
                    Submit
                  </Button>
                )}
              </Grid>
            </Grid>
          </Box>
        </>
      </Modal>
    </>
  );
};

export default UserDescriptionFormOnGoogleAuth;
